import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';

const Footer = ({ onOpenDonate }) => {
  return (
    <footer className="bg-gray-900 text-gray-100 pt-12 pb-8 border-t border-gray-800">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Organization Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-primary to-accent rounded-full flex items-center justify-center">
                <span className="text-white font-bold">C</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">CRCCM</h3>
                <p className="text-secondary text-sm">Empowering communities through giving & service</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              We partner with communities to deliver education, health, livelihoods and emergency relief.
              Join us in creating lasting change.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors transform hover:-translate-y-1 hover:scale-110" aria-label="Facebook">
                <FaFacebookF className="w-5 h-5" aria-hidden />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors transform hover:-translate-y-1 hover:scale-110" aria-label="Instagram">
                <FaInstagram className="w-5 h-5" aria-hidden />
              </a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors transform hover:-translate-y-1 hover:scale-110" aria-label="YouTube">
                <FaYoutube className="w-5 h-5" aria-hidden />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-200 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-200 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/ministries" className="text-gray-200 hover:text-white transition-colors">Programs</Link></li>
              <li><Link to="/contact" className="text-gray-200 hover:text-white transition-colors">Contact</Link></li>
              <li>
                <button
                  type="button"
                  onClick={onOpenDonate}
                  className="text-primary hover:text-white transition-colors font-semibold bg-transparent border-0 p-0 cursor-pointer"
                >
                  Donate
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-200">
              <li>📍 25 Jubud Estate Little Rayfield. Jos Plateau State.</li>
              <li>📞 <a href="tel:+2348033059716" className="hover:text-white">+234 803 305 9716</a></li>
              <li>📞 <a href="tel:+2347011035443" className="hover:text-white">+234 701 103 5443</a></li>
              <li>✉️ <a href="mailto:info@crccm.org" className="hover:text-white">christcaresglobal@gmail.com</a></li>
              <li>
                <a href="https://wa.me/2348033059716" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary hover:text-white">
                  <FaWhatsapp className="w-4 h-4" aria-hidden />
                  Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center space-y-2">
          <p className="text-gray-400">
            © {new Date().getFullYear()} CRCCM Foundation. All rights reserved. | Empowering communities through giving & service
          </p>
          <p className="text-gray-400 font-medium">
            CAC Registration: 8858434
          </p>
          <p className="text-gray-500 text-sm">
            <a
              href="https://steps-plus.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-white underline-offset-4 hover:underline"
            >
              Click here to contact developer
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;